var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWord = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#C6E1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 28.167C36.5 32.881 36.5 35.2381 35.0355 36.7025C33.5711 38.167 31.214 38.167 26.5 38.167H21.5C16.786 38.167 14.4289 38.167 12.9645 36.7025C11.5 35.2381 11.5 32.881 11.5 28.167V19.8337C11.5 15.1196 11.5 12.7626 12.9645 11.2981C14.4289 9.83366 16.786 9.83366 21.5 9.83366H26.5C31.214 9.83366 33.5711 9.83366 35.0355 11.2981C36.5 12.7626 36.5 15.1196 36.5 19.8337V28.167Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 18.5H17.5",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 23.5H17.5",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 28.5H17.5",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWord);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Word.b44c7a9d8971fe28ae1d93b5640f6554.svg";